import React from 'react';
import { Search } from 'lucide-react';

const TABS = [
  { key: 'all', label: 'All' },
  { key: 'pending', label: 'Pending' },
  { key: 'evaluated', label: 'Evaluated' },
];

const JudgeFilters = ({ status, onStatusChange, search, onSearchChange, category, onCategoryChange }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
      <div className="flex gap-2 flex-wrap">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onStatusChange(tab.key)}
            className={`px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${
              status === tab.key
                ? 'bg-primary text-white'
                : 'bg-white text-gray-600 border border-gray-200 hover:border-primary'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="flex gap-2 w-full sm:w-auto">
        <select
          value={category}
          onChange={(e) => onCategoryChange(e.target.value)}
          className="px-3 py-2 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
        >
          <option value="">All Categories</option>
          <option value="wildlife">Wildlife</option>
          <option value="nature">Nature</option>
        </select>
        <div className="relative flex-1 sm:w-64">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
          <input
            type="text"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search entry number…"
            className="w-full pl-9 pr-3 py-2 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
          />
        </div>
      </div>
    </div>
  );
};

export default JudgeFilters;